import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { required } from "../../../util/validators";
import { ImportModal } from "../../components/ImportModal";

export const ImportNonCoveredCodesModal = ({ onImport, payorId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      payorId: values.payorId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/cpt_coverage_denials/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Add Non Covered Codes from CSV..."
      initialValues={{ payorId }}
      exampleDownloadPath="/admin/cpt_coverage_denials/example"
    >
      {(formProps) => <Field component={TextInput} name="payorId" type="hidden" />}
    </ImportModal>
  );
};
